import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureHelperService } from './feature-helper.service';

@Directive({
    selector: '[checkFeatureRender]',
    standalone: false
})
export class FeatureHelperCheckRenderDirective implements OnInit {

  public feature: string;

  @Input() set checkFeatureRender(feature: string) {
    this.feature = feature;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private featureHelperService: FeatureHelperService,
    private viewContainer: ViewContainerRef
  ) { }

  ngOnInit() {
    let userFeatures = this.featureHelperService.getUserFeatures();
    let itemIndex = userFeatures.map(m => m.feature).indexOf(this.feature);
    if (itemIndex != -1) {
      if (userFeatures[itemIndex].enabled) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    } else {
      this.viewContainer.clear();
    }
  }
}
